import { Route, Switch } from 'react-router-dom';
import { DosiAppHeader } from '~/components/Dosi/App/Header/DosiAppHeader';
import { agent } from '~/components/Dosi/Vault';
import { Header } from '~/components/Header';
import { CloseButtonHeader } from '~/components/Layout/Header/CloseButton/CloseButtonHeader';
import { IsolatedHeader } from '~/components/Layout/Header/Isolated/IsolatedHeader';

export const isolatedHeaderPaths = ['/invitation'];
export const closeButtonHeaderPaths = [
  '/membership/item/citizen/levelup/go',
  '/membership/item/friend/levelup/go',
];

export const HeaderRouteSwitch = () => (
  <Switch>
    <Route path={isolatedHeaderPaths}>
      <IsolatedHeader />
    </Route>
    <Route path={closeButtonHeaderPaths}>
      <CloseButtonHeader />
    </Route>
    <Route>{agent ? <DosiAppHeader /> : <Header />}</Route>
  </Switch>
);
